import { useIntl } from 'react-intl';

import css from 'src/utils/css';
import NpsSegmentBar from './NpsSegmentBar';
import { getZonaNps, toNumber } from './npsHelpers';

const classes = css`
  .row {
    &:hover {
      background: #f8fafc;
    }
  }
`;

const styles = {
  card: {
    backgroundColor: '#fff',
    border: '1px solid #eef0f3',
    borderRadius: 12,
    boxShadow: '0 1px 2px rgba(16, 24, 40, 0.05)',
    marginTop: 16,
    padding: '20px 22px',
  },
  cardTitle: {
    color: '#101828',
    fontSize: 15,
    fontWeight: 700,
    marginBottom: 12,
  },
  tableWrap: {
    overflowX: 'auto',
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
  },
  th: {
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #eef2f7',
    color: '#98a2b3',
    fontSize: 12,
    fontWeight: 600,
    padding: '10px 12px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  thRight: {
    textAlign: 'right',
  },
  td: {
    borderTop: '1px solid #f1f4f8',
    color: '#1f2d3d',
    fontSize: 14,
    padding: '12px',
    verticalAlign: 'middle',
  },
  tdPergunta: {
    fontWeight: 500,
    minWidth: 220,
  },
  tdBar: {
    width: 200,
  },
  tdRight: {
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  scoreValue: {
    fontSize: 15,
    fontWeight: 700,
  },
  subValue: {
    color: '#98a2b3',
    fontSize: 13,
  },
};

function NpsPorPerguntaTabela({ perguntas }) {
  const intl = useIntl();

  const lista = [...(perguntas || [])].sort(
    (a, b) => toNumber(a.ordem) - toNumber(b.ordem)
  );

  if (lista.length === 0) return null;

  return (
    <div style={styles.card}>
      <div style={styles.cardTitle}>
        {intl.formatMessage({ id: 'labelDistribuicaoNpsPorPergunta' })}
      </div>
      <div style={styles.tableWrap}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>
                {intl.formatMessage({ id: 'labelPergunta' })}
              </th>
              <th style={styles.th}>
                {intl.formatMessage({ id: 'labelDistribuicao' })}
              </th>
              <th style={{ ...styles.th, ...styles.thRight }}>NPS</th>
              <th style={{ ...styles.th, ...styles.thRight }}>
                {intl.formatMessage({ id: 'labelRespostas' })}
              </th>
              <th style={{ ...styles.th, ...styles.thRight }}>
                {intl.formatMessage({ id: 'labelComentarios' })}
              </th>
            </tr>
          </thead>
          <tbody>
            {lista.map((pergunta, index) => {
              const npsScore = toNumber(pergunta.npsScore);
              const zona = getZonaNps(npsScore);

              return (
                <tr
                  className={classes.row}
                  key={pergunta.perguntaId ?? index}
                >
                  <td style={{ ...styles.td, ...styles.tdPergunta }}>
                    {pergunta.titulo}
                  </td>
                  <td style={{ ...styles.td, ...styles.tdBar }}>
                    <NpsSegmentBar
                      detratores={pergunta.detratores}
                      neutros={pergunta.neutros}
                      promotores={pergunta.promotores}
                      height={20}
                    />
                  </td>
                  <td style={{ ...styles.td, ...styles.tdRight }}>
                    <span style={{ ...styles.scoreValue, color: zona.color }}>
                      {npsScore}
                    </span>
                  </td>
                  <td
                    style={{
                      ...styles.td,
                      ...styles.tdRight,
                      ...styles.subValue,
                    }}
                  >
                    {toNumber(pergunta.totalRespostas)}
                  </td>
                  <td
                    style={{
                      ...styles.td,
                      ...styles.tdRight,
                      ...styles.subValue,
                    }}
                  >
                    {toNumber(pergunta.totalComentarios)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default NpsPorPerguntaTabela;